import { colors } from '../../colors';
var threeTile = {
  borderColor: colors.overcast,
  headingColor: colors.charcoalGrey,
  paraColor: colors.charcoalGrey,
  subHeadingColor: colors.charcoalGrey,
  bgColor: colors.pale,
  ctaColor: colors.dustyTeal,
  textColorDark: colors.charcoalGrey,
  textColorLight: colors.white,
  cardBgColorVariationC: colors.white
};
export default threeTile;